import routerOptions0 from "/Users/jdo/org/brx/please-reply/brx-please-reply/node_modules/.pnpm/nuxt@3.15.4_@parcel+watcher@2.5.1_@types+node@22.13.1_db0@0.2.4_eslint@9.20.1_jiti@2.4.2__ior_6r5an3q5f3bdm7e7ntwphtpffy/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}